import React, {useState} from 'react';

import './Group.css'
import OverlayMenu from './OverlayMenu'
import GroupSlider from './GroupSlider';

/**
 * Group component
 * Note : 그룹 컴포넌트의 scope는 Row scope (layout, components)
 * @param {Object} props 
 */
const Group = (props) => {
  // Property value
  const { 
    layout, 
    components, 
    message_index, 
    row_index, 
    id, 
    type, 
    editingIndexes, 
    messageActions,
    currentEditSlidePage, 
    isDragging,
  } = props
  // Property functions
  const { menuOnShow, menuOnHide, updateComponent, setIndex, onCopy } = props

  const onUpdate = (updatedName, updatedValue) => {
    updateComponent({
      [updatedName]: updatedValue,
    })
  }

  const onShow = (e) => {
    menuOnShow()
  }

  const onHide = (e) => {
    menuOnHide()
  }

  return (
    <div>
      {/* <OverlayMenu
        id={id}
        onUpdate={onUpdate}
        onShow={onShow} onHide={onHide}> */}
        <div class="group-component">
          {
            layout === "default" ? (
              <GroupSlider key={id} 
                components={components} 
                message_index={message_index} 
                row_index={row_index} 
                setIndex={setIndex} 
                id={id}
                type={type}
                onCopy={onCopy}
                isDragging={isDragging}
                // editingIndexes={editingIndexes}
                editing_message_index= {props.editing_message_index}
                editing_row_index= {props.editing_row_index}
                editing_slide_page_index= {props.editing_slide_page_index}
                messageActions={messageActions}
                currentEditSlidePage={currentEditSlidePage}
              />
            ) : (
              <p> 그룹 컴포넌트의 '{layout}'레이아웃은 지원되지 않는 레이아웃입니다. </p> 
            )
          }
        </div>
      {/* </OverlayMenu> */}
    </div>
  )
}

export default Group